import { List, Map } from 'immutable';
import createReducer from './createReducer';

export const NOTIFICATION_ACTIONS = {
	RESET_NOTIFICATIONS: "RESET_NOTIFICATIONS",
	ADD_NOTIFICATION:    "ADD_NOTIFICATION",
	REMOVE_NOTIFICATION: "REMOVE_NOTIFICATION",
};

export function addNotification(payload){
	return (dispatch, getState) => {
		return dispatch(buildNotificationMessage(payload, payload.id));
	};
}

export function removeNotification(payload){
	return (dispatch, getState) => {
		return dispatch({
			type: NOTIFICATION_ACTIONS.REMOVE_NOTIFICATION,
			payload,
		});
	};
}

export function buildNotificationMessage(payload, num = Math.random()){
	if(!payload.id || isNaN(payload.id)) { payload.id = `msg-${num}`; }
	return {
		type: NOTIFICATION_ACTIONS.ADD_NOTIFICATION,
		payload,
	};
}

const IT = {
		messages: List(),
	}
	, DEFAULT_MESSAGE = {
		isHidden:      false,
		messageHeader: "",
		message:       "",
		type:          "info",
	}
	, handlers = {
		[NOTIFICATION_ACTIONS.RESET_NOTIFICATIONS]: resetNotifications,
		[NOTIFICATION_ACTIONS.ADD_NOTIFICATION]:    addNotificationToUI,
		[NOTIFICATION_ACTIONS.REMOVE_NOTIFICATION]: removeNotificationFromUI,
	}
	;

function resetNotifications(state){
	return { ...IT };
}

function addNotificationToUI(state, action){
	let { messages } = state
		, { payload } = action
		;

	if(payload){
		let newMessage = new Map({ ...DEFAULT_MESSAGE, ...payload });

		if(messages.some(v => v.get("id") === payload.id)){
			newMessage = newMessage.set("id", `${payload.id}--${messages.size}`);
		}

		messages = messages.push(newMessage);
	}

	return {
		...state,
		messages,
	};
}

function removeNotificationFromUI(state, action){
	if(!action.payload.id){ return state; }

	let currentMessages = state.messages
		, currentKey = currentMessages.findKey(v => v.get("id") === action.payload.id)
		, currentItem = currentMessages.get(currentKey)
		;

	return {
		...state,
		messages: currentMessages.set(currentKey, currentItem.set("isHidden", true)),
	};
}

export default createReducer(IT, handlers);
